import { ConfigService } from '../config/config.service';

export interface Logger {
    info(...args): void;
    log(...args): void;
    error(...args): void;
}

export default class DebugService {
    constructor() {}

    /**
     * Calls console.log with @tag as the first argument and @args if @tag is in the the config list of debug tags
     * @param tag
     * @param args
     */
    static log(tag, ...args) {
        if (ConfigService.debug.includes(tag)) {
            console.log(`${tag}:`, ...args);
        }
    }

    /**
     * Calls console.error with @tag as the first argument and @args if @tag is in the the config list of debug tags
     * @param tag
     * @param args
     */
    static error(tag, ...args) {
        if (ConfigService.debug.includes(tag)) {
            console.error(`${tag}:`, ...args);
        }
    }

    /**
     * Calls console.log with @args without @tag as the first argument so you can use text styles easier
     * @param tag
     * @param args
     */
    static anonymous(tag, ...args) {
        if (ConfigService.debug.includes(tag)) {
            console.log(...args);
        }
    }

    /**
     * Calls console.trace if @tag is in the the config list of debug tags
     * @param tag
     */
    static trace(tag) {
        if (ConfigService.debug.includes(tag)) {
            console.trace();
        }
    }

    /**
     * Calls console.table with @args if @tag is in the the config list of debug tags
     * @param tag
     * @param args
     */
    static table(tag, ...args) {
        if (ConfigService.debug.includes(tag)) {
            console.table(...args);
        }
    }

    /**
     * Calls console.time with @label if @tag is in the the config list of debug tags
     * @param tag
     * @param label
     */
    static time(tag, label) {
        if (ConfigService.debug.includes(tag)) {
            console.time(label);
        }
    }

    /**
     * Calls console.timeEnd with @label if @tag is in the the config list of debug tags
     * @param tag
     * @param label
     */
    static timeEnd(tag, label) {
        if (ConfigService.debug.includes(tag)) {
            console.timeEnd(label);
        }
    }
}
